import Http from '../../../http';
import {
  ADD_DISCOUNT,
  EDIT_DISCOUNT,
  FETCH_DISCOUNTS,
  DELETE_DISCOUNT,
} from './constants';
import { startLoadingList, stopLoadingList } from '../../../common/hoc/withLoaingList';

const fetchDiscountsAction = payload => ({
  type: FETCH_DISCOUNTS,
  payload,
});

const fetchDiscounts = url => (dispatch) => {
  dispatch(startLoadingList());
  return Http.get(url)
    .then((data) => {
      dispatch(fetchDiscountsAction(data.rows));
      dispatch(stopLoadingList());

      return data;
    })
    .catch((err) => {
      dispatch(stopLoadingList());
      return err;
    });
}

export const fetchShopDiscounts = id =>
  fetchDiscounts(`/shop/${id}/discount`);
export const fetchBarberDiscounts = id =>
  fetchDiscounts(`/barber/${id}/discount`);

const addDiscountAction = data => ({
  type: ADD_DISCOUNT,
  payload: data,
});

export const addShopDiscount = (shopId, data) => dispatch =>
  Http.post(`/shop/${shopId}/discount`, data)
    .then(data => dispatch(addDiscountAction(data)));

export const addBarberDiscount = (barberId, data) => dispatch =>
  Http.post(`/barber/${barberId}/discount`, data)
    .then(data => dispatch(addDiscountAction(data)));

const editDiscountAction = data => ({
  type: EDIT_DISCOUNT,
  payload: data,
});

export const updateShopDiscount = (shopId, data) => dispatch =>
  Http.put(`/shop/${shopId}/discount/${data.id}`, data)
    .then(data => dispatch(editDiscountAction(data)));

export const updateBarberDiscount = (barberId, data) => dispatch =>
  Http.put(`/barber/${barberId}/discount/${data.id}`, data)
    .then(data => dispatch(editDiscountAction(data)));

const deleteDiscountAction = id => ({
  type: DELETE_DISCOUNT,
  payload: id,
});

export const deleteShopDiscount = (shopId, id) => dispatch =>
  Http.delete(`/shop/${shopId}/discount/${id}`)
    .then(() => dispatch(deleteDiscountAction(id)));

export const deleteBarberDiscount = (barberId, id) => dispatch =>
  Http.delete(`/barber/${barberId}/discount/${id}`)
    .then(() => dispatch(deleteDiscountAction(id)));
